import Vue from 'vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import VueCkeditor from '@ckeditor/ckeditor5-vue2/dist/ckeditor';


const options = {
  editors: {
    classic: ClassicEditor,
  },
  name: 'ckeditor',
};

Vue.use(VueCkeditor, options);
